import React from 'react';

export function ElevatorColumnFormatter(cellContent) {
  const getValue = (value) => {
    switch (value) {
      case 0:
        return 'אין מעלית'
      case 1:
        return 'מעלית קיימת'
      default:
        return ''
    }
  };

  return (
    <div
      className="text-dark-75 font-weight-bolder d-block font-size-lg text-nowrap"
      data-text={getValue(cellContent)}
    >
      {getValue(cellContent)}
    </div>
  );
}
